// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2jUZp","label":"Radio_label__2XtFn","checkMark":"Radio_checkMark__2AzyE","disabled":"Radio_disabled__13fmr"};